import { useEffect } from 'react';
import { injectIntl } from "react-intl";
import PropTypes from 'prop-types';
import useUserAccount from "../../hooks/useUserAccount";
import useEnv from "../../hooks/useEnv";

const messages = {
    authError: {
        id: "Tunnistautuminen epäonnistui. Ole hyvä ja yritä uudelleen.",
        defaultMessage: "Tunnistautuminen epäonnistui. Ole hyvä ja yritä uudelleen."
    },
    accountDeleted: {
        id: "Tili suljettu ja tiedot poistettu.",
        defaultMessage: "Tili suljettu ja tiedot poistettu."
    }
}

const LogOut = (props) => {
    const { userSignOut } = useUserAccount();
    const lng = props.intl.formatMessage;
    const { isEnvTruthy } = useEnv();

    /**
     * Logout user and redirect to frontpage
     */
    useEffect(() => {
        const signOut = async (alert) => {
            const clearCognito = !!props.location?.state?.clearCognito && isEnvTruthy('USER_ID_SIGN_IN');
            await userSignOut(true, clearCognito);
            props.history.replace({
                pathname: '/',
                alert
            });
        }
        let alert = "";
        let alertParam = null;
        if (props.location?.search) {
            const params = new URLSearchParams(props.location.search);
            alertParam = params.get('alert');
        }
        if (alertParam === 'authError') {
            alert = { message: lng(messages.authError), type: 'danger' };
        } else if (alertParam === 'accountDeleted') {
            alert = { message: lng(messages.accountDeleted), type: 'success' };
        } else if (props.location?.alert) {
            alert = props.location.alert;
        }
        void signOut(alert);
    }, []);

    return '';
};

LogOut.propTypes = {
    intl: PropTypes.object.isRequired
};

export default injectIntl(LogOut);
